import { useRouter } from 'next/router';

export const useProjectNavigate = () => {
  const router = useRouter();

  const push = (data: { path: string; replace?: boolean }) => {
    if (!data?.path) return;

    router.push(data.path);
  };

  const pop = () => {
    router.back();
  };

  const replace = (data: { url: string }) => {
    router.replace(data?.url);
  };

  return { push, pop, router, replace };
};
